///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Modal from "./Modal";
import SystemErrorModal from "./SystemErrorModal";
import { rejectBidReasons } from "../helpers/types";
import Spinner from "./icons/Spinner";
import { rejectBid } from "../api/bids";
import messages from "../helpers/messages";

const inital = { reason: null, loading: false, error: false };

export const RejectBidModal = ({ open, bidId, bidModeId, handleClose }) => {
  const [rejectDetails, setRejectDetails] = useState({ ...inital });
  const { user } = useSelector(state => state.user);

  useEffect(() => {
    !open && setRejectDetails(inital);
  }, [open]);

  const { loading, error, reason } = rejectDetails;
  const handleBidModeReject = () => {
    if (!loading) {
      setRejectDetails({ ...rejectDetails, loading: true, error: false });
      rejectBid(
        bidId,
        bidModeId,
        rejectDetails.reason,
        user.userRoleForManagementUser
      )
        .then(() => {
          setRejectDetails({ ...rejectDetails, loading: false });
          handleClose(true);
        })
        .catch(() => {
          setRejectDetails({ ...rejectDetails, error: true, loading: false });
        });
    }
  };
  const handleReasonChange = ({ target: { value } }) => {
    setRejectDetails({ ...rejectDetails, reason: parseInt(value, 10) });
  };

  return (
    <>
      <SystemErrorModal
        open={open && error}
        large
        closeModal={() => handleClose(false)}
        handleExit={() => handleClose(false)}
        handleTryAgain={handleBidModeReject}
      />
      <Modal
        title={messages.rejectBid.defaultMessage}
        open={open && !error}
        large={true}
        handleClose={() => handleClose(false)}
        titleClass="modal__title_light uppercase"
        bodyClass="border-top-grey px-24 pt-24"
        closeButtonClass="modal__close-button mr-16 mt-16"
        modalStyle={{ width: 470 }}
      >
        <p
          data-testid="reject message"
          className="font-size-16 text-dim-grey pb-4"
        >
          {messages.rejectBidMessage.defaultMessage}
        </p>
        <div>
          {rejectBidReasons.map(({ value, label }) => (
            <div key={value} className="mt-16">
              <input
                radioGroup="bid-reject"
                type="radio"
                id={value}
                value={value}
                className="mt-0 cursor-pointer"
                name="userLogin"
                onChange={handleReasonChange}
                checked={value === reason}
              />
              <label htmlFor={value} className="font-size-16 ml-24">
                {label}
              </label>
            </div>
          ))}
        </div>

        <div className="grid fr my-24">
          <div className="grid__cell pr-8">
            <button
              data-testid="exit-button"
              className="secondary-button one-whole cursor-pointer univers-67-bold-cond short-button"
              onClick={() => handleClose(false)}
            >
              {messages.exit.defaultMessage}
            </button>
          </div>
          <div className="grid__cell pl-8">
            <button
              data-testid="confirm-button"
              className="primary-button one-whole cursor-pointer univers-67-bold-cond short-button"
              onClick={handleBidModeReject}
              disabled={!reason}
            >
              {loading ? (
                <Spinner
                  fill="#FFF"
                  className="spinner mt-4"
                  height="16px"
                  width="16px"
                />
              ) : (
                messages.confirm.defaultMessage
              )}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RejectBidModal;
